import React from 'react'
import ContactForm from './contact-form'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'
import Link from '../utils/link'
import Map from './map'

const Contact = ({h1, title, content, googleMap, mapTitle, address}) => {
  return (
    <>
      <section className={`contact${!h1 ? ' contact--no-pad' : ''}`}>
        <div className="contact__inner">
          { content && 
            <div className="contact__content">
              <Fade distance='40px' bottom>
                <>
                { h1 && title && <h1>{parse(title)}</h1> }
                { !h1 && title && <h2>{parse(title)}</h2> }
                </>
              </Fade>
              { content &&
                <Fade distance='40px' bottom>
                  <div>{parse(content)}</div>
                </Fade>
              }
            </div> 
          }
          <div className="contact__form">
            <Fade distance='40px' bottom>
              <ContactForm/>
            </Fade>
          </div>
        </div>
      </section>
      <section className='map'>
        <div className='map__inner'>
          <div className='map__sidebar'>
            <Fade distance='40px' bottom>
              <h2>{parse(mapTitle)}</h2>
              <p>{parse(address)}</p>
            </Fade>
          </div>
          <div className='map__map'>
            <Fade distance='40px' bottom>
              <Map lat={googleMap.latitude} lng={googleMap.longitude} />
            </Fade>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact